import FilterDropdown from './adapter';

export default FilterDropdown;
